import { LimitErrors } from "common/constants";
import log from "js/core/logger";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";
import { ShowUpgradeDialog } from "js/react/components/Dialogs/BaseDialog";

export default class ErrorHandler {
    static handleSlideLimitReached(err, { workspaceId }) {
        if (!workspaceId) {
            throw new Error("workspaceId is required");
        }
        if (err.message === LimitErrors.SLIDE_COUNT_LIMIT_REACHED) {
            ShowUpgradeDialog({
                type: UpgradePlanDialogType.EXCEEDED_SLIDE_LIMIT,
                workspaceId,
                analytics: { "cta": "Slide Limit Reached" }
            });
        } else {
            log.error(err);
        }
    }
}
